/* eslint-disable react/jsx-no-undef */
import React, { Suspense } from "react";
import SectionSkeleton from "./sectionskeleton";
import LazySection from "components/lazySection";
import CommunityDevelopList from "components/Community-Development/communityDevelopList";
import CommBanner from "components/Community-Development/communityDevelopBanner";

const CommpDevep: React.FC = () => {
  return (
    <>
     
        <CommBanner /> 
       <LazySection fallback={<SectionSkeleton height={300} />}>
        <CommunityDevelopList />
      </LazySection> 
    </>
  );
};

export default CommpDevep;
